module.exports = __webpack_public_path__ + "img/_4.c2a2139a.png";